function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#18ea95;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "a",
  d: "M32.953,17.539l1.436.829a.405.405,0,0,1,.184.471,8.344,8.344,0,0,1-1.843,3.187.4.4,0,0,1-.5.076L30.8,21.274a6.456,6.456,0,0,1-2.047,1.184v1.657a.4.4,0,0,1-.316.395,8.423,8.423,0,0,1-3.68,0,.405.405,0,0,1-.317-.4V22.458a6.455,6.455,0,0,1-2.047-1.184l-1.435.829a.4.4,0,0,1-.5-.076,8.344,8.344,0,0,1-1.843-3.187.405.405,0,0,1,.184-.471l1.436-.829a6.52,6.52,0,0,1,0-2.366l-1.436-.829a.405.405,0,0,1-.184-.471,8.344,8.344,0,0,1,1.843-3.187.4.4,0,0,1,.5-.076l1.435.829a6.456,6.456,0,0,1,2.047-1.184V8.6a.4.4,0,0,1,.316-.395,8.423,8.423,0,0,1,3.68,0,.405.405,0,0,1,.317.4v1.657A6.455,6.455,0,0,1,30.8,11.439l1.435-.829a.4.4,0,0,1,.5.076,8.344,8.344,0,0,1,1.843,3.187.405.405,0,0,1-.184.471l-1.436.829a6.52,6.52,0,0,1,0,2.366Zm-3.666-1.183a2.7,2.7,0,1,0-2.7,2.7A2.7,2.7,0,0,0,29.288,16.356Z",
  transform: "translate(-18.592 -7.999)"
});

var SvgCog = function SvgCog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16.714,
    viewBox: "0 0 16 16.714",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cog.c4e98aa1.svg";
export { ForwardRef as ReactComponent };